






















import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component
export default class SectionKala1 extends Vue {
  @Prop({ required: true }) value!: any;
  local: any = {};

  @Watch("value", { immediate: true, deep: true })
  onValueChange(v: any) {
    const vStr = JSON.stringify(v || {});
    if (JSON.stringify(this.local) !== vStr) this.local = JSON.parse(vStr);
  }

  @Watch("local", { deep: true })
  emitInput(v: any) {
    this.$emit("input", v);
  }
}
